// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useEffect } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { MixpanelConsumer } from 'react-mixpanel';
import { trackMixpanel } from '../../infrastructure/utils/common';

const WithMixPanelRouteListener = props => {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  const { children, pageLabel, mixpanel, currentUser } = props;

  const history = useHistory();

  useEffect(() => {
    if (pageLabel === 'home') history.push('orders');
    trackMixpanel('pageViewed', { page: pageLabel }, currentUser, mixpanel);
  }, [pageLabel]);

  return <>{children}</>;
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
export default ({ component: C, props: cProps, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      cProps.isAuthenticated ? (
        <MixpanelConsumer>
          {mixpanel => (
            <WithMixPanelRouteListener
              mixpanel={mixpanel}
              {...rest}
              {...props}
              {...cProps}
            >
              <C {...props} {...cProps} />
            </WithMixPanelRouteListener>
          )}
        </MixpanelConsumer>
      ) : (
        <Redirect
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          to={`/login?redirect=${props.location.pathname}${props.location.search}`}
        />
      )
    }
  />
);
